import { baseRoutes } from "../../../helpers";

const accessRoute = {
  REVIEW: {
    path: `${baseRoutes.adminBaseRoutes}/review-list`,
  }
};

export default accessRoute;

  